class Collider extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            opener: this.querySelector(".ml_collider_opener"),
            details: this.querySelector(".ml_collider_details"),
        }

        if (this.elements?.opener) {
            this.elements.opener.onkeypress = (e) => {
                if (e.key === "Enter") {
                    console.log("innn");
                    this.elements.opener.click();
                }
            };
        }

        this.elements.opener?.addEventListener("click", (e) => {
            this.elements.opener?.classList.toggle("ml_show_collider");
            this.elements.details?.classList.toggle("ml_show_collider");

            setTimeout(() => {
                if (this.elements.details?.classList.contains("ml_show_collider")) {
                    const height = this.elements.details?.scrollHeight || 0;
                    if (this.elements.details && height > 0) {
                        this.elements.details.style.height = `${height + 40}px`;
                    }
                } else {
                    if (this.elements.details) {
                        this.elements.details.style.height = 0;
                    }
                }
            })
        }, { passive: true })
    }
}

customElements.define('ml-collider', Collider);